var map = {
	"./android/detection": 1014,
	"./androidtv/detection": 1015,
	"./arris/detection": 1016,
	"./hisense/detection": 1017,
	"./lg/detection": 1018,
	"./nagra/detection": 1019,
	"./netrange/detection": 1020,
	"./opera/detection": 1021,
	"./polaroid/detection": 1022,
	"./ps4/detection": 1023,
	"./samsung/detection": 1024,
	"./seirobotics/detection": 1025,
	"./sony/detection": 1026,
	"./stbcoship/detection": 1027,
	"./stbcoship9108/detection": 1028,
	"./stbhuawei/detection": 1029,
	"./stbkaon/detection": 1030,
	"./tizen/detection": 1031,
	"./web0s/detection": 1032,
	"./workstation/detection": 1033,
	"./workstationChafari/detection": 1034,
	"./zeasn/detection": 1035,
	"./zte/detection": 1036
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1013;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 1013
// module chunks = 0